// extracted by mini-css-extract-plugin
export var active = "_2f-b";
export var activeIndicator = "_2f-6";
export var animate = "_2f-a";
export var disabled = "_2f-c";
export var flat = "_2f-1";
export var fullWidth = "_2f-3";
export var lg = "_2f-9";
export var md = "_2f-8";
export var redoButtonTabGroup = "_2f-0";
export var sm = "_2f-7";
export var tabButton = "_2f-4";
export var tabButtonsContainer = "_2f-2";
export var xs = "_2f-5";